//export const domain = "http://api.copticlib.org"
//export const domain = "https://api.copticlib.org/";
export const domain = "https://localhost:44338/"

import PageTitle from "Components/GlobalComponents/PageTitle.vue";
import NoDataAva from "Components/GlobalComponents/NoDataAva.vue";
const GlobalComponents = {
    install(Vue) {
        Vue.component("PageTitle", PageTitle);
        Vue.component("NoDataAva", NoDataAva);
    },
};
export default GlobalComponents;